class MobileHeroHelper {
    constructor() {

    }

    animate() {
        // Close mobile tabs in page hero
        $('a[data-toggle="tab"]').on('show.bs.tab', function () {
            if (!$('.hero_form-body').hasClass('.full')) {
                $('.hero_form-body').addClass('full');
            }
            if (!$(this).hasClass('active', 'show')) {
                $(this).addClass('active', 'show');
            }
            let sibs = $($(this).parent()).siblings('li');
            $(sibs).removeClass('active');
            $(sibs).children().removeClass('active', 'show');
        });

        $('.closeTabs').on('click', function () {
            $('.hero_form-body').removeClass('full');
            $($($('.nav-item.mobile')).find('a')).removeClass('active', 'show');
            // var tabPane = $(this).closest('.tab-pane');
            // if (tabPane.hasClass('active')) {
            //     tabPane.toggleClass('show');
            //     tabPane.toggleClass('active');
            //     var activeNav = $('.hero_form-nav .nav-item.active');
            //     var activeLink = $('.hero_form-nav .nav-link.active');
            //     activeNav.toggleClass('active');
            //     activeLink.toggleClass('show');
            //     activeLink.toggleClass('active');
            // }
        });
        $('.menu-toggle').click(function () {
            $($($('.nav-item.mobile')[0]).find('a')).addClass('active');
            $('#mob_checkRegistration').addClass('active', 'show');
            $('.hero_form-body').addClass('full');

        });
    }
}

window.app.add('mobileHero', new MobileHeroHelper());